export const downloadAsFile = (string, name, type = 'text/html') => {
    const element = document.createElement("a");
    const file = new Blob([string], {type: type});
    element.href = URL.createObjectURL(file);
    element.download = name;
    document.body.appendChild(element);
    element.click();
    element.remove();
}